import { app } from '../../../../../app';

app.factory('SaaspassConnectDevelopersService', SaaspassConnectDevelopersService);

/** @ngInject */
function SaaspassConnectDevelopersService($resource) {
    var rootUrl = 'app/rest/admin/company/:companyId/saaspassconnects/:connectId/credentials';

    return {
        saaspassConnectCredentialsUrl: rootUrl,
        saaspassConnectCredentials : $resource(rootUrl,{},{'updateSaaspassConnect' : {
            method : 'PUT',
        }})

    }
    

}


// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/manage/developers/developers.service.js